module.exports = __webpack_public_path__ + "img/about_cards.57d23cc5.jpg";